export const statusConvert = (status: string) => {
	switch (status) {
		case 'pending':
			return 'Pendiente'
		case 'viewed':
			return 'Visto'

		default:
			break
	}
}
